import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getOrdersProducts, manageRating } from '@/api/order';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = [];
    this.loading = false;
    this.listLoading = false;
    this.rules = {};
    this.tableKey = 0;
    this.orderId = null;
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.orderId = this.$route.params && this.$route.params.id;
    this.fetchData(this.orderId);
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(orderId) {
    try {
      this.listLoading = true;
      this.formData = await getOrdersProducts(getQuery({
        orderId,
        filter: {
          orderId: 'eq'
        }
      }));
      // Just for test
      const title = 'Manage Rating';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      await manageRating(this.orderId, this.formData);
      this.$notify({
        title: 'Success',
        message: 'Ratings updated successfully',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      router.push({
        path: '/order/list',
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'OrdersRatingDetail'
})], default_1);
export default default_1;